import type { FlyCutCaptionLocale } from './index';
import { defaultLocale } from './index';

const zhCN: FlyCutCaptionLocale = defaultLocale;

export default zhCN;